import { DefaultRequest } from 'scripts/api';

class EventRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = 'Event';
    const model = App.Models.Event;
    const collectionClass = App.Collections.Events;

    super(entityName, model, collectionClass);

    if (Monet.Session.isLogged) {
      Greenmile.Event.AutoComplete.loadEmailAvailableTags();
    }
  }

  initializeMonetSession = () => {
    Monet.Session = Monet.Session || {};
    Monet.Session.EventsManage = {
      geoTabsOnSaved: [],
      geoTabsOnTreeView: []
    };
  }

  form_new = () => {
    App.Objects.Event.initializeMonetSession();
    App.Objects.Event.createForm();
  }

  edit = (eventId) => {
    App.Objects.Event.initializeMonetSession();
    App.Objects.Event.eventEdit(eventId);
  }

  create = () => {
    App.Objects.Event.saveEvents();
  }

  update = () => {
    App.Objects.Event.saveEvents();
  }

  eventEdit = (eventID) => {
    const callbackFunction = () => {
      const criteria = '{"filters":["*","organization.*","description","actions.*","actions.eventLibraryAction.*","actions.i18NLocale.*","checks.*","checks.eventLibraryCheck.*","eventType.*"]}';
      const request = new DefaultRequest({
        url: `Event/restrictions?criteria=${criteria}`,
        method: 'POST',
        data: {
          criteriaChain: [
            {
              and: [
                {
                  attr: "id",
                  eq: eventID
                }
              ]
            }
          ]
        },
        success: (response) => {
          const data = response[0];
          const form = App.Forms.Event.form;
          const model = new App.Models.Event(data);
          form.setModel(model);
          form.populateFields(new App.Models.Event(data));
          if (form.fields.requiresAck.getValue()) {
            form.fields.requiresComment.enable();
          }
          if (data.checks) {
            data.checks.forEach((check) => {
              if (check.externalID) {
                App.Views.Event.renderGeoTabCheckBox(check);
                Monet.Session.EventsManage.geoTabsOnSaved.push(check);
              } else {
                App.Views.Event.renderCheckBox(check.eventLibraryCheck, check);
              }
            });
          }
          if (data.actions) {
            data.actions.forEach((action) => {
              App.Views.Event.renderActionBox(action.eventLibraryAction, action);
            });

            const httpRequestData = data.actions.find((action) => action.eventLibraryAction.key === "HTTP_REQUEST")

            if(httpRequestData) {
              const jsonPostEventData = JSON.parse(httpRequestData.jsonParameter);

              Greenmile.Event.EventActionUtil.setHttpRequestUrlPreview(jsonPostEventData);
              Greenmile.Event.EventActionUtil.setHttpRequestHeadersPreview();
            }
          }
          Greenmile.Event.AddAttribute.updateBubblingMask(data.messageBody, '#Event_messageBody');
        }
      });
      request.send();
    };
    App.Objects.Event.createForm(callbackFunction);
  }

  getCheckRules = () => {
    const rules = [];
    const checksSelected = [...document.querySelectorAll('*[id^=check-form-]')];
    const eventsCheck = Monet.Session.EventsManage.eventsCheck;

    checksSelected.forEach((checkSelected, index) => {
      const eventId = checkSelected.getAttribute('eventId');
      const eventParsed = (eventId.match(/^\d+$/g)) ? parseInt(eventId, 10) : eventId;
      const eventCheckId = parseInt(checkSelected.getAttribute('eventcheckid'), 10);
      const check = eventsCheck.reduce((acc, actual) => (
        actual.eventLibraryChecks.reduce((accLibrary, actualLibrary) => {
          const id = (actualLibrary.externalID) ? actualLibrary.externalID : actualLibrary.id;
          if (id === eventParsed) {
            const mapped = {};
            if (eventCheckId) {
              mapped.id = eventCheckId;
            }
            if (actualLibrary.externalID) {
              mapped.externalID = actualLibrary.externalID;
              mapped.jsonParameter = 'null';
              mapped.externalDescription = actualLibrary.externalDescription;
              if (actualLibrary.externalComment) {
                mapped.externalComment = actualLibrary.externalComment;
              }
              if (actualLibrary.externalHelpResource) {
                mapped.externalHelpResource = actualLibrary.externalHelpResource;
              }
            } else {
              mapped.eventLibraryCheck = {
                id: actualLibrary.id
              };
              if (actualLibrary.htmlTemplate) {
                const retrieveParameter = App.Views.Event.layouts[actualLibrary.htmlTemplate].retrieveParameter;
                if (retrieveParameter) {
                  mapped.jsonParameter = retrieveParameter();
                }
              }
            }
            accLibrary.push(mapped);
          }
          return accLibrary;
        }, acc)
      ), [])[0];
      check.sequenceOrder = index;
      rules.push(check);
    });

    return rules;
  }

  getActions = () => {
    const actions = [];
    const actionsSelected = [...document.querySelectorAll('*[id^=action-form-]')];
    const actionsCheck = Monet.Session.EventsManage.eventsAction;

    actionsSelected.forEach((checkSelected, index) => {
      const eventId = parseInt(checkSelected.getAttribute('eventId'), 10);
      const eventActionId = parseInt(checkSelected.getAttribute('eventactionid'), 10);
      const check = actionsCheck.reduce((acc, actual) => (
        actual.eventLibraryActions.reduce((accLibrary, actualLibrary) => {
          const id = (actualLibrary.externalID) ? actualLibrary.externalID : actualLibrary.id;
          if (id === eventId) {
            const mapped = {};
            mapped.eventLibraryAction = {
              id: actualLibrary.id
            };
            mapped.i18NLocale = {
              id: Monet.I18n.locale.id
            };
            if (eventActionId) {
              mapped.id = eventActionId;
            }
            mapped.jsonParameter = Greenmile.Event.call(actualLibrary.jsRetrieveParameter)();

            const { authConfigurationId } = JSON.parse(mapped.jsonParameter);

            mapped.authConfigurationId = authConfigurationId;

            accLibrary.push(mapped);
          }
          return accLibrary;
        }, acc)
      ), [])[0];
      check.sequenceOrder = index;
      actions.push(check);
    });
    return actions;
  }

  saveEvents = () => {
   let form = App.Forms.Event.form;
   let validation = Greenmile.Event.Validator.validateEvents(form.validate());

    if (!validation.errorMessages.length) {
      let idEvent = '';
      let editRoute = '';
      let actionType = 'POST';
      const eventToSave = form.getValues();
      form.triggerLoadingBtns();

      if (window.location.hash.indexOf('edit')) {
        const id = window.location.hash.replace('#/Event/edit/', '');
        idEvent = (id) ? parseInt(id, 10) : id;
      }

      eventToSave.scheduleCron = 'STR';
      eventToSave.checks = App.Objects.Event.getCheckRules();
      eventToSave.actions = App.Objects.Event.getActions();

      if (idEvent) {
        actionType = 'PUT';
        editRoute = `/${idEvent}`;
      }

      const request = new DefaultRequest({
        url: `Event${editRoute}`,
        data: eventToSave,
        method: actionType,
        success: () => {
          window.location = '#/Event';
        },
        error: (xhr) => {
          App.Views.Event.inlineMessage(JSON.parse(xhr.responseText));
          setTimeout(() => {
            form.triggerLoadingBtns();
          }, 1500);
        }
      });
      request.send();
    } else {
      App.Views.Event.inlineMessage(validation);
    }
  }

  createForm = (callbackFunction) => {
    const crud = (callbackFunction) ? 'edit' : 'new';
    const entity = 'Event';
    App.Forms[entity] = App.Forms[entity] || {};
    App.Forms[entity].layout = App.Forms[entity].layout || {};

    if (!App.Forms[entity].layout[crud]) {
      const ajax = new Monet.Ajax();
      ajax.url = `form/${entity}/${crud}`;
      ajax.method = 'GET';
      ajax.success = (data) => {
        const layout = data || [];
        const pageLayout = new Monet.PageLayout(layout);
        const dm = new Monet.Builder.DataMapper();
        App.Forms[entity].layout[crud] = layout;
        dm.setEntity(entity);
        const fields = dm.parseFieldList(pageLayout.getFields());
        dm.addFieldsToDataMapper(fields);
        dm.build(() => {
          App.Views.Event.renderForm(crud, callbackFunction);
        });
      };
      ajax.send();
    } else {
      App.Views.Event.renderForm(crud, callbackFunction);
    }
    return this;
  }

  mountTreeRules = (data) => {
    const nodes = App.Views.Event.formatItemsRulesOfTree(data);
    App.Views.Event.mountTreeCheck(nodes);
  }

  loadEventsCheck = () => {
    const library = new App.Collections.EventsLibraryCheck();
    library.fetch({
      success(collection) {
        Monet.Session.EventsManage.eventsCheck = collection.at(0).attributes.gmeventChecks;
        App.Objects.Event.mountTreeRules(collection);
      },
    });
  }

  loadEventsAction = () => {
    const libraryAction = new App.Collections.EventsLibraryAction();
    libraryAction.fetch({
      success(data) {
        Monet.Session.EventsManage.eventsAction = data.models.map(model => model.attributes);
        App.Views.Event.mountTreeAction(App.Views.Event.formatItemsActionsOfTree(data));
      },
    });
  }
}

App.Routers.Event = EventRouter;
